import { COOKIE_CONSENT_POLICY_VERSION } from 'helpers/cookie-consent'

export const COOKIE_CONSENT_SYNC_ACTIONS = Object.freeze({
    syncLocalToServer: 'syncLocalToServer',
    useServer: 'useServer',
    waitForUserChoice: 'waitForUserChoice',
})

/**
 * Check whether cookie consent belongs to the current policy version
 * @param {object|null} cookieConsent Cookie consent data
 * @returns {boolean} Is current policy consent
 */
export function isCurrentPolicyCookieConsent(cookieConsent) {
    return !!cookieConsent && cookieConsent.policyVersion === COOKIE_CONSENT_POLICY_VERSION
}

/**
 * Check whether first cookie consent was updated after second cookie consent
 * @param {object} firstCookieConsent First cookie consent data
 * @param {object} secondCookieConsent Second cookie consent data
 * @returns {boolean} Is first consent newer
 */
export function isCookieConsentNewer(firstCookieConsent, secondCookieConsent) {
    const firstUpdatedAt = new Date(firstCookieConsent?.updatedAt)
    const secondUpdatedAt = new Date(secondCookieConsent?.updatedAt)

    if (Number.isNaN(firstUpdatedAt.getTime()))
        return false

    if (Number.isNaN(secondUpdatedAt.getTime()))
        return true

    return firstUpdatedAt.getTime() > secondUpdatedAt.getTime()
}

/**
 * Get the cookie consent synchronization action between localStorage and server data
 * @param {object|null} localCookieConsent Local cookie consent
 * @param {object|null} serverCookieConsent Server cookie consent
 * @returns {string} Cookie consent synchronization action
 */
export function getCookieConsentSynchronizationAction(localCookieConsent, serverCookieConsent) {
    if (localCookieConsent) {
        if (!isCurrentPolicyCookieConsent(serverCookieConsent)
            || isCookieConsentNewer(localCookieConsent, serverCookieConsent))
            return COOKIE_CONSENT_SYNC_ACTIONS.syncLocalToServer

        return COOKIE_CONSENT_SYNC_ACTIONS.useServer
    }

    if (isCurrentPolicyCookieConsent(serverCookieConsent))
        return COOKIE_CONSENT_SYNC_ACTIONS.useServer

    return COOKIE_CONSENT_SYNC_ACTIONS.waitForUserChoice
}
